<script setup lang="ts">
import type {
  IEmblaDotsProps,
  IEmblaDotsEmits,
} from '@/shared/ui/EmblaCarousel/model/types/emblaCarousel';

withDefaults(defineProps<IEmblaDotsProps>(), {
  selectedItemIndex: 0,
  lengthDots: 1,
  isMobile: false,
});

const emit = defineEmits<IEmblaDotsEmits>();

const handlerClick = (index: number): void => {
  emit('click', index);
};

defineExpose({ handlerClick });
</script>

<template>
  <div ref="emblaDots" :class="['bullets', { _mobile: isMobile }]">
    <button
      v-for="(_, indexDot) in lengthDots"
      :key="indexDot"
      class="bullets__item"
      :class="{ '_is-selected': selectedItemIndex === indexDot }"
      type="button"
      :aria-label="`Слайд ${indexDot + 1}`"
      :aria-current="selectedItemIndex === indexDot ? 'true' : undefined"
      @click="handlerClick(indexDot)"
    ></button>
  </div>
</template>

<style lang="less">
.bullets {
  display: flex;
  align-items: center;

  &__item {
    width: @size-x2;
    height: @size-x2;
    margin-right: @size-x4;
    cursor: pointer;
    padding: 0;
    border: none;
    border-radius: 100%;
    background-color: @color-silver-chalice;

    &._is-selected {
      background-color: @color-persimmon;
      width: 15px;
      height: 15px;
    }

    &:last-child {
      margin-right: 0;
    }
  }

  &._mobile {
    transition: @A transform;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  &._mobile &__item {
    display: inline-block;
    border-radius: 50%;
    width: @size-x2;
    height: @size-x2;
    opacity: 0.5;
    min-width: @size-x2;
    min-height: @size-x2;
    margin-right: @size-x3;
    background-color: @color-persimmon;
    transform: none;
    transition: @A transform;

    &:last-child {
      margin-right: 0;
    }

    &._is-selected {
      background-color: tomato;
      opacity: 1;
    }
  }
}
</style>
